import {
  PreloadedState,
  combineReducers,
  configureStore,
} from '@reduxjs/toolkit';

import { api as codesApi } from './apis/codes-api';
import { api as frontendApi } from './apis/frontend-api';
import { informeraApi } from './apis/informera-api';
import { api as imagesApi } from './apis/images-api';
import { appConfigSlice } from './features/app-config/slice';
import { localStorage as appConfigLocalStorage } from './features/app-config/middlewares';
import { codeFiltersSlice } from './features/code-filters/slice';
import { codeSearchSlice } from './features/code-search/slice';
import { ctaSlice } from './features/cta/slice';
import { localStorage as ctaLocalStorage } from './features/cta/middlewares';
import { graphApi } from './graph';

const rootReducer = combineReducers({
  appConfigSlice: appConfigSlice.reducer,
  codeFiltersSlice: codeFiltersSlice.reducer,
  codeSearchSlice: codeSearchSlice.reducer,
  ctaSlice: ctaSlice.reducer,
  codesApi: codesApi.reducer,
  frontendApi: frontendApi.reducer,
  imagesApi: imagesApi.reducer,
  [informeraApi.reducerPath]: informeraApi.reducer,
  [graphApi.reducerPath]: graphApi.reducer,
});

export function setupStore(preloadedState?: PreloadedState<RootState>) {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        appConfigLocalStorage.middleware,
        ctaLocalStorage.middleware,
        codesApi.middleware,
        frontendApi.middleware,
        imagesApi.middleware,
        informeraApi.middleware,
        graphApi.middleware
      ),
    preloadedState,
  });
}

export const store = setupStore();

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
